import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './mobile.scss';

function MobileCV() {
  const navigate = useNavigate();
  const [typeText, setTypeText] = useState('');
  const [telRevealed, setTelRevealed] = useState(false);
  const strings = ['Rigoureux', 'Organisé', "Esprit d'équipe"];
  const ci = useRef(0);
  const si = useRef(0);

  useEffect(() => {
    let iv;

    function type() {
      setTypeText(strings[ci.current].substring(0, si.current + 1));
      si.current++;
      if (si.current === strings[ci.current].length) {
        clearInterval(iv);
        setTimeout(() => { iv = setInterval(del, 50); }, 1200);
      }
    }

    function del() {
      setTypeText(strings[ci.current].substring(0, si.current - 1));
      si.current--;
      if (si.current === 0) {
        clearInterval(iv);
        ci.current = (ci.current + 1) % strings.length;
        setTimeout(() => { iv = setInterval(type, 100); }, 250);
      }
    }

    iv = setInterval(type, 100);
    return () => clearInterval(iv);
  }, []);

  return (
    <div className="mobile-cv">

      {/* HERO */}
      <header className="hero" id="home">
        <svg className="hero-bolt" viewBox="0 0 80 140" width="110" fill="white" aria-hidden="true">
          <path d="M48 0L8 76h30L16 140l56-84H42L48 0z"/>
        </svg>



        <h1>Philippe<br/><span>GENOT</span></h1>

        <p className="hero-sub">
          <span>{typeText}</span>
          <span className="cursor">|</span>
        </p>

        <div className="hero-btns">
          <a href="#contact" className="btn btn-fill">
            <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/></svg>
            Me contacter
          </a>
          <a href="/cv.pdf" target="_blank" rel="noreferrer" className="btn btn-ghost">
            <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16" aria-hidden="true"><path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd"/></svg>
            Télécharger le CV (PDF)
          </a>
          <a href="#projects" className="btn btn-ghost">
            <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
            Mes projets
          </a>
        </div>
      </header>

      {/* À PROPOS */}
      <div className="pad">
        <div className="section-head" id="about">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>À propos</h2>
        </div>
        <div className="about-card">
          <strong>Passionné de travaux techniques et manuels</strong>, je me suis d'abord orienté vers le développement web et je cherche désormais à approfondir mes compétences techniques pour me spécialiser à terme dans les <strong>systèmes énergétiques & bâtiments connectés</strong>.<br/><br/>
          Ma formation en développement web m'a <strong>habitué à la logique, à la résolution de problèmes complexes et à la justesse méthodologique</strong>, des compétences qui constituent <strong>des atouts que je souhaite mettre au service de vos équipes</strong>.<br/><br/>
          <strong>Consciencieux et curieux</strong>, j'apprécie les environnements où la qualité d'exécution est primordiale. <strong>Ma capacité d'adaptation et mon autonomie me permettront de monter en compétences rapidement</strong> au contact de vos techniciens expérimentés.
        </div>
      </div>

      {/* COMPÉTENCES */}
      <div className="pad">
        <div className="section-head" id="skills">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>Compétences</h2>
        </div>
        <div className="skill-cats">
          <div className="skill-cat">
            <div className="skill-cat-title">Électricité BT</div>
            <div className="skill-tags">
              <span className="stag">Câblage 230V monophasé</span>
              <span className="stag">Lecture de schémas</span>
              <span className="stag">Raccordements Wago / borniers</span>
              <span className="stag">Porte-fusibles & protections</span>
              <span className="stag">Mesure au multimètre</span>
              <span className="stag">Diagnostic de pannes</span>
              <span className="stag">Normes BT / TBTS</span>
            </div>
          </div>
          <div className="skill-cat">
            <div className="skill-cat-title">Électronique & mesure</div>
            <div className="skill-tags">
              <span className="stag">Câblage ESP32</span>
              <span className="stag">Soudures électroniques</span>
              <span className="stag">Convertisseurs AC/DC 230V→5V</span>
              <span className="stag">Mesure de tension & intensité</span>
              <span className="stag">Transformateur de courant (CT)</span>
              <span className="stag">Suivi de consommation</span>
            </div>
          </div>
          <div className="skill-cat">
            <div className="skill-cat-title">Domotique & IoT</div>
            <div className="skill-tags">
              <span className="stag">Programmation ESP32 / Arduino</span>
              <span className="stag">Interface web embarquée</span>
              <span className="stag">Communication Wi-Fi</span>
              <span className="stag">Télécommande d'équipements</span>
              <span className="stag">Supervision énergétique</span>
            </div>
          </div>
          <div className="skill-cat">
            <div className="skill-cat-title">Développement Web</div>
            <div className="skill-tags">
              <span className="stag">JavaScript / React / Vue.js</span>
              <span className="stag">PHP / WordPress</span>
              <span className="stag">HTML / CSS</span>
              <span className="stag">Node.js</span>
              <span className="stag">Docker</span>
            </div>
          </div>
        </div>
      </div>

      {/* EXPÉRIENCES */}
      <div className="pad">
        <div className="section-head" id="work">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>Expériences</h2>
        </div>
        <div className="timeline">
          <div className="tl-item">
            <div className="tl-date">Avr. 2026 — Actuellement</div>
            <div className="tl-title">Développeur web indépendant</div>
            <div className="tl-company">Auto-entrepreneur, Montpellier</div>
          </div>
          <div className="tl-item">
            <div className="tl-date">Nov. 2024 — Mars 2026</div>
            <div className="tl-title">Assistant Administratif</div>
            <div className="tl-company">Montpellier Dépannage, Montpellier</div>
          </div>
          <div className="tl-item">
            <div className="tl-date">Août 2023 — Nov. 2024</div>
            <div className="tl-title">Responsable de boutique</div>
            <div className="tl-company">Drôle de Pain, boulangerie artisanale, Montpellier</div>
          </div>
          <div className="tl-item">
            <div className="tl-date">Juin — Août 2023</div>
            <div className="tl-title">Stage Développement Web</div>
            <div className="tl-company">ASAP Studio, Montpellier</div>
            <ul className="tl-bullets">
              <li>JavaScript Vanilla & PHP sur projets WordPress</li>
              <li>Composants Nuxt / Vue.js sur projet interne</li>
            </ul>
          </div>
          <div className="tl-item">
            <div className="tl-date">Sept. 2022 — Sept. 2023</div>
            <div className="tl-title">TP Développeur Web & Web Mobile — RNCP niv. 5</div>
            <div className="tl-company">Formation BeWeb / Fondespierre, Montpellier</div>
          </div>
          <div className="tl-item">
            <div className="tl-date">Oct. 2021 — Juin 2022</div>
            <div className="tl-title">Formateur Junior à distance</div>
            <div className="tl-company">ATE Formation, Montpellier</div>
            <ul className="tl-bullets">
              <li>FLE, Anglais, Espagnol, Pack Office / Microsoft 365</li>
            </ul>
          </div>
          <div className="tl-item">
            <div className="tl-date">Janv. 2019 — Sept. 2021</div>
            <div className="tl-title">Vendeur en boulangerie</div>
            <div className="tl-company">Drôle de Pain, boulangerie artisanale, Montpellier</div>
          </div>
        </div>
      </div>

      {/* FORMATION */}
      <div className="pad">
        <div className="section-head" id="formations">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>Formation</h2>
        </div>
        <div className="form-list">
          <div className="form-item">
            <div className="form-badge done">✓</div>
            <div>
              <div className="form-title">TP Développeur Web & Web Mobile — RNCP niv. 5</div>
              <div className="form-sub">BeWeb / Fondespierre, Montpellier · 2023</div>
            </div>
          </div>
          <div className="form-item">
            <div className="form-badge done">✓</div>
            <div>
              <div className="form-title">Baccalauréat STMG</div>
              <div className="form-sub">Lycée Le Corbusier, Poissy · 2014</div>
            </div>
          </div>
        </div>
      </div>

      {/* LANGUES */}
      <div className="pad">
        <div className="section-head" id="languages">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>Langues</h2>
        </div>
        <div className="form-list">
          <div className="form-item">
            <div className="form-badge done"><img src="/img/icons/france.png" style={{width:'18px',height:'18px',objectFit:'contain'}} alt="FR"/></div>
            <div>
              <div className="form-title">Français</div>
              <div className="form-sub">Langue maternelle</div>
            </div>
          </div>
          <div className="form-item">
            <div className="form-badge done"><img src="/img/icons/espana.png" style={{width:'18px',height:'18px',objectFit:'contain'}} alt="ES"/></div>
            <div>
              <div className="form-title">Espagnol</div>
              <div className="form-sub">Excellent</div>
            </div>
          </div>
          <div className="form-item">
            <div className="form-badge done"><img src="/img/icons/uk.png" style={{width:'18px',height:'18px',objectFit:'contain'}} alt="EN"/></div>
            <div>
              <div className="form-title">Anglais</div>
              <div className="form-sub">Très bon</div>
            </div>
          </div>
        </div>
      </div>

      {/* PROJETS */}
      <div className="pad">
        <div className="section-head" id="projects">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>Projets</h2>
        </div>
        <div className="proj-list">
          <div className="proj-card" onClick={() => navigate('/multiprise')} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && navigate('/multiprise')}>
            <img className="proj-cover" src="/img/projets/multiprise/cover.jpg" alt="Multiprise connectée ESP32" />
            <div className="proj-info">
              <div className="proj-badge">IoT</div>
              <div className="proj-name">Multiprise Connectée</div>
              <div className="proj-desc">ESP32 · 230V · Wi-Fi · Interface web</div>
            </div>
            <svg viewBox="0 0 20 20" fill="currentColor" width="18" className="proj-arrow" aria-hidden="true"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/></svg>
          </div>
          <a className="proj-card" href="https://philippegenot.com/nasa" target="_blank" rel="noreferrer" style={{textDecoration:'none',color:'inherit'}}>
            <img className="proj-cover" src="/img/nasa_pro.png" alt="My NASA Project" />
            <div className="proj-info">
              <div className="proj-badge">API</div>
              <div className="proj-name">My NASA Project</div>
              <div className="proj-desc">PHP · Tailwind · Docker · API NASA</div>
            </div>
            <svg viewBox="0 0 20 20" fill="currentColor" width="18" className="proj-arrow" aria-hidden="true"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/></svg>
          </a>
          <a className="proj-card" href="https://www.vers-lavenir.com/" target="_blank" rel="noreferrer" style={{textDecoration:'none',color:'inherit'}}>
            <img className="proj-cover" src="/img/projets/vers-lavenir.webp" alt="Vers l'Avenir" />
            <div className="proj-info">
              <div className="proj-badge">Web</div>
              <div className="proj-name">Vers l'Avenir</div>
              <div className="proj-desc">vers-lavenir.com</div>
            </div>
            <svg viewBox="0 0 20 20" fill="currentColor" width="18" className="proj-arrow" aria-hidden="true"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/></svg>
          </a>
          <a className="proj-card" href="https://www.axel-genot.com" target="_blank" rel="noreferrer" style={{textDecoration:'none',color:'inherit'}}>
            <img className="proj-cover" src="/img/projets/axel-genot.webp" alt="Axel Genot" />
            <div className="proj-info">
              <div className="proj-badge">Web</div>
              <div className="proj-name">Axel Genot</div>
              <div className="proj-desc">axel-genot.com</div>
            </div>
            <svg viewBox="0 0 20 20" fill="currentColor" width="18" className="proj-arrow" aria-hidden="true"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/></svg>
          </a>
        </div>
      </div>

      {/* CONTACT */}
      <div className="pad">
        <div className="section-head" id="contact">
          <svg className="bolt" viewBox="0 0 24 24" width="14" height="14" fill="#5b8aff" aria-hidden="true"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
          <h2>Contact</h2>
        </div>
        <div className="contact-list">
          {!telRevealed ? (
            <button className="contact-row" onClick={() => setTelRevealed(true)} aria-label="Afficher le numéro de téléphone">
              <div className="c-icon">
                <svg viewBox="0 0 20 20" fill="#556078" aria-hidden="true"><path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/></svg>
              </div>
              <div>
                <div className="c-label">Téléphone</div>
                <div className="c-value">Afficher le numéro</div>
              </div>
              <svg className="c-arrow" viewBox="0 0 20 20" fill="currentColor" width="16" aria-hidden="true"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/></svg>
            </button>
          ) : (
            <a href="tel:+33668028697" className="contact-row" aria-label="Appeler le 06 68 02 86 97">
              <div className="c-icon">
                <svg viewBox="0 0 20 20" fill="#556078" aria-hidden="true"><path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/></svg>
              </div>
              <div>
                <div className="c-label">Téléphone</div>
                <div className="c-value revealed">06 68 02 86 97</div>
              </div>
              <svg className="c-arrow" viewBox="0 0 20 20" fill="currentColor" width="16" aria-hidden="true"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/></svg>
            </a>
          )}
          <a href="mailto:philippe_genot@hotmail.fr?subject=J'ai vu ton CV en ligne" className="contact-row">
            <div className="c-icon">
              <svg viewBox="0 0 20 20" fill="#6b7a99" aria-hidden="true"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/></svg>
            </div>
            <div>
              <div className="c-label">Email</div>
              <div className="c-value">philippe_genot@hotmail.fr</div>
            </div>
            <svg className="c-arrow" viewBox="0 0 20 20" fill="currentColor" width="16" aria-hidden="true"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"/></svg>
          </a>
        </div>
      </div>

      <p className="mobile-footer">
        Prêt à mettre mon énergie à votre service.<br/>
        <strong>Philippe GENOT · Montpellier</strong>
      </p>

    </div>
  );
}

export default MobileCV;
